import { create } from "zustand";

export type NotificationVariant = "success" | "error" | "info";

export interface AppNotification {
  id: number;
  message: string;
  variant: NotificationVariant;
  createdAt: number;
  read: boolean;
}

interface NotificationState {
  items: AppNotification[];
  push: (message: string, variant?: NotificationVariant) => void;
  markAllRead: () => void;
  markRead: (id: number) => void;
  clear: () => void;
}

let notificationId = 0;
const MAX_ITEMS = 50;

export const useNotificationStore = create<NotificationState>((set) => ({
  items: [],
  push: (message, variant = "info") => {
    const item: AppNotification = {
      id: ++notificationId,
      message,
      variant,
      createdAt: Date.now(),
      read: false,
    };
    set((state) => ({
      items: [item, ...state.items].slice(0, MAX_ITEMS),
    }));
  },
  markAllRead: () =>
    set((state) => ({
      items: state.items.map((n) => ({ ...n, read: true })),
    })),
  markRead: (id) =>
    set((state) => ({
      items: state.items.map((n) =>
        n.id === id ? { ...n, read: true } : n
      ),
    })),
  clear: () => set({ items: [] }),
}));

export function getUnreadCount(items: AppNotification[]): number {
  return items.filter((n) => !n.read).length;
}
